export const textCompletionTranslations = {
    en: {
        instructions: 'Tap a word, then tap a gap. Tap an inserted word to return it before completing the text.',
        dragHint: 'You can also drag words into the gaps.',
        selected: 'Selected: {{word}}. Tap a gap in the text.',
        emptyGap: 'Gap {{number}}',
        filledGap: 'Gap {{number}}: {{word}}. Tap to return the word.',
    },
    es: {
        instructions: 'Toca una palabra y después un hueco. Toca una palabra insertada para devolverla antes de completar el texto.',
        dragHint: 'También puedes arrastrar las palabras a los huecos.',
        selected: 'Seleccionada: {{word}}. Toca un hueco del texto.',
        emptyGap: 'Hueco {{number}}',
        filledGap: 'Hueco {{number}}: {{word}}. Toca para devolver la palabra.',
    },
    fr: {
        instructions: 'Touchez un mot, puis un espace vide. Touchez un mot inséré pour le remettre dans la liste avant de terminer le texte.',
        dragHint: 'Vous pouvez aussi faire glisser les mots dans les espaces vides.',
        selected: 'Mot sélectionné : {{word}}. Touchez un espace vide du texte.',
        emptyGap: 'Espace {{number}}',
        filledGap: 'Espace {{number}} : {{word}}. Touchez pour remettre le mot dans la liste.',
    },
};
